import {Injectable} from '@angular/core';
import {Patient, PatientBasic, PatientStatistics} from "@shared/api/models/query/patient.model";
import {PaginatorService} from "@shared/api/services/paginator.service";
import {CrudService} from "@shared/api/services/crud.service";
import {GetService} from "@shared/api/services/get.service";
import {firstValueFrom, map, Observable, Subject} from "rxjs";
import {PatientUpdate} from "@shared/api/models/command/patient.model";
import {BreadcrumbItem} from "@cdss/services/breadcrumb-item.value";

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {

    private content = new Subject<BreadcrumbItem[]>();
    content$ = this.content.asObservable();

    set(content: BreadcrumbItem[]) {
        this.content.next(content);
    }
}
